// extracted by mini-css-extract-plugin
export var orderSummary = "_os-0";
export var showMoreLessButton = "_os-1";